import React, { useEffect } from "react";
import { NavLink } from "react-router";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main className="container mx-auto px-4 py-8 text-white">
      <h1 className="text-4xl font-bold text-center mb-8">PRIVACY POLICY</h1>
      <div className="space-y-6 text-lg leading-relaxed">
        <p className="text-center">Effective date: 09/07/2026</p>
        <p className="font-bold underline">
          1. <span className="inline-block text-[7pt]"></span>
          Introduction
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p>
          Welcome to <b>PearEasy Aps</b>.
        </p>
        <p>
          PearEasy Aps (“us”, “we”, or “our”) operates easysbc.io and easySBC
          mobile application(hereinafter referred to as “<b>Service</b>”).
        </p>
        <p>
          Our Privacy Policy governs your visit to easysbc.io and easySBC mobile
          application, and explains how we collect, safeguard and disclose
          information that results from your use of our Service.
        </p>
        <p>
          We use your data to provide and improve Service. By using Service, you
          agree to the collection and use of information in accordance with this
          policy. Unless otherwise defined in this Privacy Policy, the terms
          used in this Privacy Policy have the same meanings as in our Terms and
          Conditions.
        </p>
        <p>
          Our Terms and Conditions (“<b>Terms</b>”) govern all use of our
          Service and together with the Privacy Policy constitutes your
          agreement with us (“<b>agreement</b>”).
        </p>
        <p className="font-bold underline">
          2. <span className="inline-block text-[7pt]"></span>
          Definitions
        </p>
        <p className="font-bold">SERVICE</p>
        <p>
          means the easysbc.io website and easySBC mobile application operated
          byPearEasy Aps.
        </p>
        <p className="font-bold">PERSONAL DATA</p>
        <p>
          means data about a living individual who can be identified from those
          data (or from those and other information either in our possession or
          likely to come into our possession).
        </p>
        <p className="font-bold">USAGE DATA</p>
        <p>
          is data collected automatically either generated by the use of Service
          or from Service infrastructure itself (for example, the duration of a
          page visit).
        </p>
        <p className="font-bold">COOKIES</p>
        <p>
          are small files stored on your device (computer or mobile device).
        </p>
        <p className="font-bold">DATA CONTROLLER</p>
        <p>
          means a natural or legal person who (either alone or jointly or in
          common with other persons) determines the purposes for which and the
          manner in which any personal data are, or are to be, processed. For
          the purpose of this Privacy Policy, we are a Data Controller of your
          data.
        </p>
        <p className="font-bold">DATA PROCESSORS (OR SERVICE PROVIDERS)</p>
        <p>
          means any natural or legal person who processes the data on behalf of
          the Data Controller. We may use the services of various Service
          Providers in order to process your data more effectively.
        </p>
        <p className="font-bold">DATA SUBJECT</p>
        <p>is any living individual who is the subject of Personal Data.</p>
        <p className="font-bold">THE USER</p>
        <p>
          is the individual using our Service. The User corresponds to the Data
          Subject, who is the subject of Personal Data.
        </p>
        <p className="font-bold underline">
          3. <span className="inline-block text-[7pt]"></span>
          Information Collection and Use
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p>
          We collect several different types of information for various purposes
          such as to provide and improve our Service to you as well as the
          marketing our Service.
        </p>
        <p className="font-bold underline">
          4. <span className="inline-block text-[7pt]"></span>
          Types of Data Collected
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p className="font-bold">Personal Data</p>
        <p>
          While using our Service, we may ask you to provide us with certain
          personally identifiable information that can be used to contact or
          identify you (“<b>Personal Data</b>”). Personally identifiable
          information may include, but is not limited to:
        </p>
        <p className="ml-8">(a) Email address</p>
        <p className="ml-4"></p>
        <p className="ml-8">(b) First and last name</p>
        <p className="ml-4"></p>
        <p className="ml-8">(c) Cookies and Usage Data</p>
        <p className="ml-4"></p>
        <p>
          We may use your Personal Data to contact you with newsletters,
          marketing or promotional materials and other information that may be
          of interest to you. You may opt out of receiving any, or all, of these
          communications from us by following the unsubscribe link.
        </p>
        <p className="font-bold">Usage Data</p>
        <p>
          We may also collect information that your browser sends whenever you
          visit our Service or when you access Service by or through a mobile
          device (“<b>Usage Data</b>”).
        </p>
        <p>
          When you access Service with a mobile device, this Usage Data may
          include information such as the type of mobile device you use, your
          mobile device unique ID, the IP address of your mobile device, your
          mobile operating system, the type of mobile Internet browser you use,
          unique device identifiers and other diagnostic data.
        </p>
        <p>
          We may also collect data related to your in-game resources, including
          but not limited to owned cards, formations, tactics, coins, and card
          attributes. This data helps us provide a personalized gaming
          experience, improve our services, and optimize gameplay.
        </p>
        <p className="font-bold">Tracking Cookies Data</p>
        <p>
          We use cookies and similar tracking technologies to track the activity
          on our Service and we hold certain information.
        </p>
        <p>
          Cookies are files with a small amount of data which may include an
          anonymous unique identifier. Cookies are sent to your browser from a
          website and stored on your device. Other tracking technologies are
          also used such as beacons, tags and scripts to collect and track
          information and to improve and analyze our Service.
        </p>
        <p>
          You can instruct your browser to refuse all cookies or to indicate
          when a cookie is being sent. However, if you do not accept cookies,
          you may not be able to use some portions of our Service.
        </p>
        <p>Examples of Cookies we use:</p>
        <p className="ml-8">
          (a) <b>Session Cookies:</b> We use Session Cookies to operate our
          Service.
        </p>
        <p className="ml-8">
          (b) <b>Preference Cookies:</b> We use Preference Cookies to remember
          your preferences and various settings.
        </p>
        <p className="font-bold underline">
          5. <span className="inline-block text-[7pt]"></span>
          Use of Data
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p>PearEasy Aps uses the collected data for various purposes:</p>
        <p className="ml-8">(a) to provide and maintain our Service;</p>
        <p className="ml-8">(b) to notify you about changes to our Service;</p>
        <p className="ml-8">
          (c) to allow you to participate in interactive features of our Service
          when you choose to do so;
        </p>
        <p className="ml-8">(d) to provide customer support;</p>
        <p className="ml-8">
          (e) to gather analysis or valuable information so that we can improve
          our Service;
        </p>
        <p className="ml-8">(f) to monitor the usage of our Service;</p>
        <p className="ml-8">
          (g) to detect, prevent and address technical issues;
        </p>
        <p className="ml-8">
          (h) to fulfill any other purpose for which you provide it;
        </p>
        <p className="ml-8">
          (i) to carry out our obligations and enforce our rights arising from
          any contracts entered into between you and us, including for billing
          and collection;
        </p>
        <p className="ml-8">
          (j) to provide you with notices about your account and/or
          subscription, including expiration and renewal notices,
          email-instructions, etc.;
        </p>
        <p className="ml-8">
          (k) to provide you with news, special offers and general information
          about other goods, services and events which we offer that are similar
          to those that you have already purchased or enquired about unless you
          have opted not to receive such information;
        </p>
        <p className="ml-8">
          (l) in any other way we may describe when you provide the information;
        </p>
        <p className="ml-8">(m) for any other purpose with your consent.</p>
        <p className="font-bold underline">
          6. <span className="inline-block text-[7pt]"></span>
          Retention of Data
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p>
          We will retain your Personal Data only for as long as is necessary for
          the purposes set out in this Privacy Policy. We will retain and use
          your Personal Data to the extent necessary to comply with our legal
          obligations (for example, if we are required to retain your data to
          comply with applicable laws), resolve disputes, and enforce our legal
          agreements and policies.
        </p>
        <p>
          We will also retain Usage Data for internal analysis purposes. Usage
          Data is generally retained for a shorter period, except when this data
          is used to strengthen the security or to improve the functionality of
          our Service, or we are legally obligated to retain this data for
          longer time periods.
        </p>
        <p className="font-bold underline">
          7. <span className="inline-block text-[7pt]"></span>
          Transfer of Data
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p>
          Your information, including Personal Data, may be transferred to – and
          maintained on – computers located outside of your state, province,
          country or other governmental jurisdiction where the data protection
          laws may differ from those of your jurisdiction.
        </p>
        <p>
          Your consent to this Privacy Policy followed by your submission of
          such information represents your agreement to that transfer.
        </p>
        <p>
          PearEasy Aps will take all the steps reasonably necessary to ensure
          that your data is treated securely and in accordance with this Privacy
          Policy and no transfer of your Personal Data will take place to an
          organisation or a country unless there are adequate controls in place
          including the security of your data and other personal information.
        </p>
        <p className="font-bold underline">
          8. <span className="inline-block text-[7pt]"></span>
          Disclosure of Data
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p>
          We may disclose personal information that we collect, or you provide:
        </p>
        <p className="ml-8">
          (a) <b>Disclosure for Law Enforcement.</b> Under certain
          circumstances, we may be required to disclose your Personal Data if
          required to do so by law or in response to valid requests by public
          authorities.
        </p>
        <p className="ml-8">
          (b) <b>Business Transaction.</b> If we or our subsidiaries are
          involved in a merger, acquisition or asset sale, your Personal Data
          may be transferred.
        </p>
        <p className="font-bold underline">
          9. <span className="inline-block text-[7pt]"></span>
          Security of Data
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p>
          The security of your data is important to us but remember that no
          method of transmission over the Internet or method of electronic
          storage is 100% secure. While we strive to use commercially acceptable
          means to protect your Personal Data, we cannot guarantee its absolute
          security.
        </p>
        <p className="font-bold underline">
          10. <span className="inline-block text-[7pt]"></span>
          Your Data Protection Rights Under General Data Protection Regulation
          (GDPR)
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p>
          If you are a resident of the European Union (EU) and European Economic
          Area (EEA), you have certain data protection rights, covered by GDPR.
          – See more at{" "}
          <a
            href="https://eur-lex.europa.eu/eli/reg/2016/679/oj"
            className="text-blue-400 underline"
          >
            https://eur-lex.europa.eu/eli/reg/2016/679/oj
          </a>
        </p>
        <p>
          We aim to take reasonable steps to allow you to correct, amend,
          delete, or limit the use of your Personal Data.
        </p>
        <p>
          If you wish to be informed what Personal Data we hold about you and if
          you want it to be removed from our systems, please email us at
          peareasy.sbc@gmail.com.
        </p>
        <p>
          In certain circumstances, you have the following data protection
          rights:
        </p>
        <p className="ml-8">
          (a) the right to access, update or to delete the information we have
          on you;
        </p>
        <p className="ml-8">
          (b) the right of rectification. You have the right to have your
          information rectified if that information is inaccurate or incomplete;
        </p>
        <p className="ml-8">
          (c) the right to object. You have the right to object to our
          processing of your Personal Data;
        </p>
        <p className="ml-8">
          (d) the right of restriction. You have the right to request that we
          restrict the processing of your personal information;
        </p>
        <p className="ml-8">
          (e) the right to data portability. You have the right to be provided
          with a copy of your Personal Data in a structured, machine-readable
          and commonly used format;
        </p>
        <p className="ml-8">
          (f) the right to withdraw consent. You also have the right to withdraw
          your consent at any time where we rely on your consent to process your
          personal information;
        </p>
        <p>
          Please note that we may ask you to verify your identity before
          responding to such requests. Please note, we may not be able to
          provide Service without some necessary data.
        </p>
        <p>
          You have the right to complain to a Data Protection Authority about
          our collection and use of your Personal Data. For more information,
          please contact your local data protection authority in the European
          Economic Area (EEA).
        </p>
        <p className="font-bold underline">
          11. <span className="inline-block text-[7pt]"></span>
          Your Data Protection Rights under the California Privacy Protection
          Act (CalOPPA)
        </p>
        <p>
          <b>
            <u></u>
          </b>
        </p>
        <p>
          If you are a California resident, you are entitled to learn what data
          we collect about you, ask to delete your data and not to sell (share)
          it. To exercise your data protection rights, you can make certain
          requests and ask us:
        </p>
        <p className="ml-8">
          (a){" "}
          <span className="text-[10pt] font-arial">
            users can visit our site anonymously;
          </span>
        </p>
        <p className="ml-8">
          (b){" "}
          <span className="text-[10pt] font-arial">
            our Privacy Policy link includes the word “Privacy”, and can easily
            be found on the page specified above on the home page of our
            website;
          </span>
        </p>
        <p className="ml-8">
          (c){" "}
          <span className="text-[10pt] font-arial">
            users will be notified of any privacy policy changes on our Privacy
            Policy Page;
          </span>
        </p>
        <p className="ml-8">
          (d){" "}
          <span className="text-[10pt] font-arial">
            users are able to change their personal information by emailing us
            at peareasy.sbc@gmail.com.
          </span>
        </p>
        <p className="font-bold underline">
          12. <span className="inline-block text-[7pt]"></span>
          Your Data Protection Rights under the California Consumer Privacy Act
          (CCPA)
        </p>
        <p>
          If you are a California resident, you are entitled to learn what data
          we collect about you, ask to delete your data and not to sell (share)
          it. To exercise your data protection rights, you can make certain
          requests and ask us:
        </p>
        <p className="ml-8">
          (a){" "}
          <span className="text-[10pt] font-arial">
            What personal information we have about you. If you make this
            request, we will return to you:
          </span>
        </p>
        <p className="ml-8">
          (i){" "}
          <span className="text-[10pt] font-arial">
            The categories of personal information we have collected about you.
          </span>
        </p>
        <p className="ml-8">
          (ii){" "}
          <span className="text-[10pt] font-arial">
            The categories of sources from which we collect your personal
            information.
          </span>
        </p>
        <p className="ml-8">
          (iii){" "}
          <span className="text-[10pt] font-arial">
            The business or commercial purpose for collecting or selling your
            personal information.
          </span>
        </p>
        <p className="ml-8">
          (iv){" "}
          <span className="text-[10pt] font-arial">
            The categories of third parties with whom we share personal
            information.
          </span>
        </p>
        <p className="font-bold underline">
          13. <span className="inline-block text-[7pt]"></span>
          Service Providers
        </p>
        <p>
          We may employ third party companies and individuals to facilitate our
          Service (“<b>Service Providers</b>”), provide Service on our behalf,
          perform Service-related services or assist us in analysing how our
          Service is used.
        </p>
        <p>
          These third parties have access to your Personal Data only to perform
          these tasks on our behalf and are obligated not to disclose or use it
          for any other purpose.
        </p>
        <p className="font-bold underline">
          14. <span className="inline-block text-[7pt]"></span>
          Analytics and Diagnostics
        </p>
        <p>
          We may use third-party Service Providers to monitor and analyze the
          use of our Service.
        </p>
        <p>
          We do not sell your personal data and we do not use any third-party
          artificial-intelligence service. To operate and improve our apps we
          share limited data with the providers listed below, who act as
          processors on our behalf.
        </p>
        <p className="font-arial font-medium">Google Analytics</p>
        <p>
          Google Analytics is a web analytics service offered by Google that
          tracks and reports website traffic. Google uses the data collected to
          track and monitor the use of our Service. This data is shared with
          other Google services. Google may use the collected data to
          contextualise and personalise the ads of its own advertising network.
        </p>
        <p>
          For more information on the privacy practices of Google, please visit
          the Google Privacy Terms web page:{" "}
          <a
            href="https://policies.google.com/privacy?hl=en"
            className="text-blue-400 underline"
          >
            https://policies.google.com/privacy?hl=en
          </a>
        </p>
        <p className="font-arial font-medium">ChartMogul</p>
        <p>
          We use ChartMogul, a subscription analytics service, to help us
          monitor and analyze subscription metrics and business performance.
          ChartMogul processes billing and subscription data on our behalf in
          order to provide insights into metrics such as revenue, churn, and
          customer lifetime value. ChartMogul acts as a Data Processor under
          GDPR, and PearEasy Aps remains the Data Controller. ChartMogul may
          process certain personal data such as customer identifiers, plan
          information, billing events, and subscription lifecycle data. We
          minimize the use of personally identifiable information where
          possible, and ChartMogul provides tools to delete or anonymize data in
          accordance with data subject rights.
        </p>
        <p>
          ChartMogul hosts its services within the European Union and offers a
          Data Processing Agreement (DPA) including Standard Contractual Clauses
          (SCCs) to ensure adequate safeguards for any international data
          transfers. For more information on the privacy practices of
          ChartMogul, please visit their Privacy Policy:{" "}
          <a
            href="https://chartmogul.com/privacy"
            className="text-blue-400 underline"
          >
            https://chartmogul.com/privacy.
          </a>
        </p>
        <p className="font-arial font-medium">Mixpanel</p>
        <p>
          We use Mixpanel (Mixpanel, Inc.) for product analytics in our mobile
          application. Mixpanel receives a pseudonymous account identifier,
          device type, operating system and app version, an approximate region
          derived from your IP address, and in-app actions such as screens
          viewed, Squad Building Challenges solved and filter options selected.
          We use this data to understand how our Service is used and to improve
          its features. Mixpanel acts as a Data Processor under GDPR and
          PearEasy Aps remains the Data Controller. Data is stored in
          Mixpanel&apos;s EU data region.
        </p>
        <p>
          For more information on the privacy practices of Mixpanel, please
          visit their Privacy Policy:{" "}
          <a
            href="https://mixpanel.com/legal/privacy-policy/"
            className="text-blue-400 underline"
          >
            https://mixpanel.com/legal/privacy-policy/
          </a>
        </p>
        <p className="font-arial font-medium">Sentry</p>
        <p>
          We use Sentry (Functional Software, Inc.) for crash reporting and
          diagnostics in our mobile application. Sentry receives crash logs and
          stack traces, device, operating system and app version context, and a
          pseudonymous account identifier. We use this data to detect and fix
          crashes and other technical issues. Sentry acts as a Data Processor
          under GDPR and PearEasy Aps remains the Data Controller.
        </p>
        <p>
          For more information on the privacy practices of Sentry, please visit
          their Privacy Policy:{" "}
          <a
            href="https://sentry.io/privacy/"
            className="text-blue-400 underline"
          >
            https://sentry.io/privacy/
          </a>
        </p>
        <p className="font-arial font-medium">RevenueCat</p>
        <p>
          We use RevenueCat (RevenueCat, Inc.) to manage in-app subscriptions in
          our mobile application. RevenueCat receives a pseudonymous account
          identifier, the store transaction identifiers provided by Apple or
          Google, purchase and subscription events such as the plan bought, its
          billing period, renewals, cancellations and expiry, the store country,
          and device, operating system and app version context. We use this data
          to grant your subscription and keep it in sync across your devices.
          RevenueCat acts as a Data Processor under GDPR and PearEasy Aps
          remains the Data Controller.
        </p>
        <p>
          RevenueCat hosts its services in the United States and offers a Data
          Processing Agreement (DPA) including Standard Contractual Clauses
          (SCCs) to ensure adequate safeguards for international data transfers.
          For more information on the privacy practices of RevenueCat, please
          visit their Privacy Policy:{" "}
          <a
            href="https://www.revenuecat.com/privacy/"
            className="text-blue-400 underline"
          >
            https://www.revenuecat.com/privacy/
          </a>
        </p>
        <p>
          We do not send your name, password or payment information to Mixpanel,
          Sentry or RevenueCat. Each is contractually bound under a Data
          Processing Agreement (DPA) to protect your data to an equivalent
          standard and to process it only on our instructions. If you wish to
          opt out of analytics, please contact us at{" "}
          <a
            href="mailto:support@easysbc.io"
            className="text-blue-400 underline"
          >
            support@easysbc.io
          </a>
          .
        </p>
        <p className="font-bold underline">
          15. <span className="inline-block text-[7pt]"></span>
          CI/CD tools
        </p>
        <p>
          We may use third-party Service Providers to automate the development
          process of our Service.
        </p>
        <p className="font-bold underline">
          16. <span className="inline-block text-[7pt]"></span>
          Payments
        </p>
        <p>
          We may provide paid products and/or services within Service. In that
          case, we use third-party services for payment processing (e.g. payment
          processors).
        </p>
        <p>
          We will not store or collect your payment card details. That
          information is provided directly to our third-party payment processors
          whose use of your personal information is governed by their Privacy
          Policy. These payment processors adhere to the standards set by
          PCI-DSS as managed by the PCI Security Standards Council, which is a
          joint effort of brands like Visa, Mastercard, American Express and
          Discover. PCI-DSS requirements help ensure the secure handling of
          payment information.
        </p>
        <p>The payment processors we work with are:</p>
        <p className="font-arial font-medium">
          Apple App Store and Google Play:
        </p>
        <p>
          Subscriptions purchased inside our mobile application are processed by
          Apple or Google, depending on your platform. We never receive or store
          your payment card details; we receive only confirmation of the
          purchase and its status. Their privacy practices can be viewed at{" "}
          <a
            href="https://www.apple.com/legal/privacy/"
            className="text-blue-400 underline"
          >
            https://www.apple.com/legal/privacy/
          </a>{" "}
          and{" "}
          <a
            href="https://policies.google.com/privacy?hl=en"
            className="text-blue-400 underline"
          >
            https://policies.google.com/privacy?hl=en
          </a>
        </p>
        <p className="font-arial font-medium">Stripe:</p>
        <p>
          Their Privacy Policy can be viewed at:{" "}
          <a
            href="https://stripe.com/us/privacy"
            className="text-blue-400 underline"
          >
            https://stripe.com/us/privacy
          </a>
        </p>
        <p className="font-bold underline">
          17. <span className="inline-block text-[7pt]"></span>
          Links to Other Sites
        </p>
        <p>
          Our Service may contain links to other sites that are not operated by
          us. If you click a third party link, you will be directed to that
          third party's site. We strongly advise you to review the Privacy
          Policy of every site you visit.
        </p>
        <p>
          We have no control over and assume no responsibility for the content,
          privacy policies or practices of any third party sites or services.
        </p>
        <p className="font-bold underline">
          18. <span className="inline-block text-[7pt]"></span>
          Children's Privacy
        </p>
        <p>
          Our Services are not intended for use by children under the age of 18
          (“<b>Child</b>” or “<b>Children</b>”).
        </p>
        <p>
          We do not knowingly collect personally identifiable information from
          Children under 18. If you become aware that a Child has provided us
          with Personal Data, please contact us. If we become aware that we have
          collected Personal Data from Children without verification of parental
          consent, we take steps to remove that information from our servers.
        </p>
        <p className="font-bold underline">
          19. <span className="inline-block text-[7pt]"></span>
          Changes to This Privacy Policy
        </p>
        <p>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page.
        </p>
        <p>
          We will let you know via email and/or a prominent notice on our
          Service, prior to the change becoming effective and update “effective
          date” at the top of this Privacy Policy.
        </p>
        <p>
          You are advised to review this Privacy Policy periodically for any
          changes. Changes to this Privacy Policy are effective when they are
          posted on this page.
        </p>
        <p className="font-bold underline">
          20. <span className="inline-block text-[7pt]"></span>
          Contact Us
        </p>
        <p></p>
        <p>
          If you have any questions about this Privacy Policy, please{" "}
          <NavLink to="/contact" className="text-blue-400 underline">
            contact us
          </NavLink>
        </p>
        <p className="font-bold underline">
          21. <span className="inline-block text-[7pt]"></span>
          <h3>Mediavine Programmatic Advertising (Ver 1.1)</h3>
        </p>
        <p>
          The Website works with Mediavine to manage third-party interest-based
          advertising appearing on the Website. Mediavine serves content and
          advertisements when you visit the Website, which may use first and
          third-party cookies. A cookie is a small text file which is sent to
          your computer or mobile device (referred to in this policy as a
          “device”) by the web server so that a website can remember some
          information about your browsing activity on the Website.
        </p>
        <p>
          First party cookies are created by the website that you are visiting.
          A third-party cookie is frequently used in behavioral advertising and
          analytics and is created by a domain other than the website you are
          visiting. Third-party cookies, tags, pixels, beacons and other similar
          technologies (collectively, “Tags”) may be placed on the Website to
          monitor interaction with advertising content and to target and
          optimize advertising. Each internet browser has functionality so that
          you can block both first and third-party cookies and clear your
          browser’s cache. The "help" feature of the menu bar on most browsers
          will tell you how to stop accepting new cookies, how to receive
          notification of new cookies, how to disable existing cookies and how
          to clear your browser’s cache. For more information about cookies and
          how to disable them, you can consult the information at{" "}
          <a
            href="https://www.allaboutcookies.org/manage-cookies/"
            target="_blank"
            rel="noreferrer noopener nofollow"
            className="text-blue-400 underline"
          >
            All About Cookies
          </a>
          .
        </p>
        <p>
          Without cookies you may not be able to take full advantage of the
          Website content and features. Please note that rejecting cookies does
          not mean that you will no longer see ads when you visit our Site. In
          the event you opt-out, you will still see non-personalized
          advertisements on the Website.
        </p>
        <p>
          The Website collects the following data using a cookie when serving
          personalized ads:
        </p>
        <ul>
          <li>IP Address</li>
          <li>Operating System type</li>
          <li>Operating System version</li>
          <li>Device Type</li>
          <li>Language of the website</li>
          <li>Web browser type</li>
          <li>Email (in hashed form)</li>
        </ul>
        <p>
          Mediavine Partners (companies listed below with whom Mediavine shares
          data) may also use this data to link to other end user information the
          partner has independently collected to deliver targeted
          advertisements. Mediavine Partners may also separately collect data
          about end users from other sources, such as advertising IDs or pixels,
          and link that data to data collected from Mediavine publishers in
          order to provide interest-based advertising across your online
          experience, including devices, browsers and apps. This data includes
          usage data, cookie information, device information, information about
          interactions between users and advertisements and websites,
          geolocation data, traffic data, and information about a visitor’s
          referral source to a particular website. Mediavine Partners may also
          create unique IDs to create audience segments, which are used to
          provide targeted advertising.
        </p>
        <p>
          If you would like more information about this practice and to know
          your choices to opt-in or opt-out of this data collection, please
          visit{" "}
          <a
            href="https://thenai.org/opt-out/"
            target="_blank"
            rel="noreferrer noopener nofollow"
            className="text-blue-400 underline"
          >
            National Advertising Initiative opt out page
          </a>
          . You may also visit{" "}
          <a
            href="http://optout.aboutads.info/#/"
            target="_blank"
            rel="noreferrer noopener nofollow"
            className="text-blue-400 underline"
          >
            Digital Advertising Alliance website
          </a>{" "}
          and{" "}
          <a
            href="http://optout.networkadvertising.org/#"
            target="_blank"
            rel="noreferrer noopener nofollow"
            className="text-blue-400 underline"
          >
            Network Advertising Initiative website
          </a>{" "}
          to learn more information about interest-based advertising. You may
          download the AppChoices app at{" "}
          <a
            href="https://youradchoices.com/appchoices"
            target="_blank"
            rel="noreferrer noopener nofollow"
            className="text-blue-400 underline"
          >
            Digital Advertising Alliance’s AppChoices app
          </a>{" "}
          to opt out in connection with mobile apps, or use the platform
          controls on your mobile device to opt out.
        </p>
        <p>
          For specific information about Mediavine Partners, the data each
          collects and their data collection and privacy policies, please visit{" "}
          <a
            href="https://www.mediavine.com/ad-partners/"
            target="_blank"
            rel="noreferrer noopener nofollow"
            className="text-blue-400 underline"
          >
            Mediavine Partners
          </a>
          .
        </p>
      </div>
    </main>
  );
};

export default Privacy;
